<template>
  <v-btn :prepend-icon="icon" class="mt-3" block size="small" variant="text" @click="toggleTheme">
    {{ t(`theme.${resolved}`) }}
  </v-btn>
</template>

<script setup lang="ts">
import { useI18n } from "@/composables/useI18n";
import { useThemePreference } from "@/composables/useThemePreference";

const { t } = useI18n();
const { resolved, icon, toggleTheme } = useThemePreference();
</script>
